import { StringSchema } from "yup";

const emailValidator = new StringSchema().email();

export async function emailValidate(value: string): Promise<boolean> {
  try {
    await emailValidator.validate(value);
    return true;
  } catch (e) {
    return false;
  }
}
